import {
	applyAcsScheduleFilter,
	focusAcsSchedule,
	openAcsScheduleSection,
} from './adapter';
import {
	openAcsScheduleCreateModal,
	openAcsScheduleDeleteModal,
	openAcsScheduleEditModal,
} from './modal';
import {resolveAcsSchedules} from './resolver';

/**
 * ACS Schedule profiles.
 *
 * ACS Schedules sit beside the SSID Schedules already handled
 * here, and are a different thing: channel selection, not SSIDs.
 *
 * Declares no fields: the Add and Edit forms are not mapped, so the agent
 * finds a profile and opens the form rather than filling it in. Delete
 * opens the confirmation and stops - the person presses the button.
 */
const acsSchedulePlugin = {
	id: 'acs_schedule',
	version: 1,
	commandVersion: 1,
	resource: 'acs_schedule',
	operations: ['options', 'list', 'search', 'create', 'edit', 'delete'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['profile.dashboard'],
	},
	sections: {
		'profile.acs_schedules': openAcsScheduleSection,
	},
	resolvers: {
		acs_schedule: resolveAcsSchedules,
	},
	filters: {
		acs_schedule: (command) => applyAcsScheduleFilter(command.params?.query),
	},
	focusHandlers: {
		acs_schedule: (command) => focusAcsSchedule(command.params?.entity_id),
	},
	modals: {
		'acs_schedule.create': openAcsScheduleCreateModal,
		'acs_schedule.edit': openAcsScheduleEditModal,
		'acs_schedule.delete': openAcsScheduleDeleteModal,
	},
};

export default acsSchedulePlugin;
